export default __webpack_public_path__ + "static/media/illustration-simple-ui.dfb875ac.svg";